module.exports = __webpack_public_path__ + "a1d8fa04ae8aff1cbf5713fb62c14ede.svg";